export const getADUserState = (state) => state.user;
//# sourceMappingURL=auth.reducers.js.map